// Centralized client config. Change IDLE_TIMEOUT_MS here to adjust the idle auto-lock.
export const IDLE_TIMEOUT_MS = 15 * 60 * 1000; // 15 minutes of inactivity
export const RESUME_KEY = "meraaj_resume_route"; // route saved on idle logout, restored on next login
